// extracted by mini-css-extract-plugin
export default {"col":"UserProductVariationsCol_col__ki2xC","title":"UserProductVariationsCol_title__BBgIJ","list":"UserProductVariationsCol_list__FUF6y"};